import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 9,
	viewBox: "0 0 12 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5 1.75L5.04261 7.04202C4.64139 7.43108 3.99917 7.41578 3.61693 7.00806L1.5 4.75",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})
});
export default SvgCheck;
